// extracted by mini-css-extract-plugin
export default {"emptyListBox":"vD2VC_skOD4wryhF3He2","description":"ON19kVsmkJoVbR_QKjDw","small":"MKMXT4pQK6hjt0MynFxS","medium":"owIRl3FK879Sn7mJF2R7"};